import { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import { client, fmtDate } from "@/lib/api";

export function ChecklistSummary({ onOpen }) {
  const [data, setData] = useState(null);
  useEffect(() => { client.get("/admin/checklist").then(r => setData(r.data)).catch(() => {}); }, []);
  const pct = data?.total ? Math.round((data.done / data.total) * 100) : 0;
  return <div className="checklist" data-testid="checklist-summary">
    <h2>Yayın kontrolü</h2>
    <p className="muted">ETBİS, yasal metinler ve teknik hazırlık maddeleri.</p>
    <strong className="summary-pct" data-testid="checklist-summary-pct">%{pct}</strong>
    <div className="progress-bar"><i style={{ width: `${pct}%` }} /></div>
    <small className="muted">{data ? `${data.done} / ${data.total} madde tamamlandı` : "Yükleniyor…"}</small>
    <button className="btn ghost small full" style={{ marginTop: 14 }} onClick={onOpen} data-testid="checklist-open-button">Listeyi aç</button>
    {pct < 100 && <div className="notice">Eksik maddeler varken yayına almadan önce yönetici kontrolü gerekir.</div>}
  </div>;
}

export function Checklist() {
  const [data, setData] = useState(null), [notes, setNotes] = useState({}), [busy, setBusy] = useState("");
  const load = () => client.get("/admin/checklist").then(r => { setData(r.data); setNotes(Object.fromEntries(r.data.items.map(i => [i.id, i.note || ""]))); });
  useEffect(() => { load(); }, []);
  async function save(id, body) { setBusy(id); try { await client.patch(`/admin/checklist/${id}`, body); await load(); } finally { setBusy(""); } }
  if (!data) return <p className="muted">Yükleniyor…</p>;
  const groups = [...new Set(data.items.map(i => i.group))];
  const pct = data.total ? Math.round((data.done / data.total) * 100) : 0;
  return <div data-testid="checklist-panel">
    <div className="table-title"><h2><ShieldCheck size={18} /> ETBİS & Yayın Kontrol Listesi</h2><span data-testid="checklist-progress">{data.done}/{data.total} tamamlandı · %{pct}</span></div>
    <div className="progress-bar"><i style={{ width: `${pct}%` }} data-testid="checklist-progress-bar" /></div>
    {pct < 100 && <div className="notice" data-testid="checklist-warning">Tüm maddeler tamamlanmadan siteyi yayına almayın. Yasal metinler ve ETBİS kaydı zorunludur.</div>}
    {groups.map(g => <div className="check-group" key={g}>
      <h3>{g}</h3>
      {data.items.filter(i => i.group === g).map(i => <div className={i.done ? "check-item done" : "check-item"} key={i.id} data-testid={`checklist-item-${i.id}`}>
        <label className="check"><input type="checkbox" checked={!!i.done} disabled={busy === i.id} onChange={e => save(i.id, { done: e.target.checked })} data-testid={`checklist-toggle-${i.id}`} /><span><strong>{i.title}</strong><small>{i.description}</small></span></label>
        <div className="check-note">
          <input value={notes[i.id] ?? ""} placeholder="Not ekle (örn. başvuru no, tarih, sorumlu)" onChange={e => setNotes({ ...notes, [i.id]: e.target.value })} onBlur={() => (notes[i.id] ?? "") !== (i.note || "") && save(i.id, { note: notes[i.id] })} data-testid={`checklist-note-${i.id}`} />
          {i.updated_at && <small className="muted">{i.updated_by} · {fmtDate(i.updated_at)}</small>}
        </div>
      </div>)}
    </div>)}
  </div>;
}
